<template>
  <!-- Sticky action bar: bleeds into the page container's padding so it spans
       edge-to-edge and stays pinned above the scrolling form body. -->
  <div
    class="tw-sticky tw-top-0 tw-z-20 -tw-mx-4 tw-mb-5 tw-border-b tw-border-surface-200 tw-bg-[#f9fafd]/90 tw-px-4 tw-py-3 tw-backdrop-blur dark:tw-border-neutral-800 dark:tw-bg-neutral-950/90"
  >
    <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
      <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
        <h1
          class="tw-truncate tw-font-heading tw-text-xl tw-font-bold tw-tracking-tight tw-text-secondary-900 dark:tw-text-neutral-50"
        >
          {{ title }}
        </h1>
        <slot name="meta" />
      </div>
      <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-2">
        <slot name="actions" />
      </div>
    </div>
    <slot name="banner" />
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
}

defineProps<Props>();
</script>
